
const { EventEmitter } = require('event-emitter');
const { initNamespaceStorage } = require('js-storage');


class UserInfoSpyApi extends EventEmitter {
	constructor () {
		super();

		this._storage = initNamespaceStorage('user-info-spy').localStorage;
	}

	isSet (k) {
		return this._storage.isSet(k);
	}

	get (k) {
		return this._storage.get(k);
	}

	set (k, v) {
		this._storage.set(k, v);

		this.emit('change', k, v);
	}
}

module.exports = new UserInfoSpyApi;

